import {
  PUT_TRANSPORTCOMPANIES_CATALOG,
  PUT_TRANSPORTCOMPANIES_CATALOG_SUCCESS,
  PUT_TRANSPORTCOMPANIES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const putTransportCompaniesCatalogRed = (
  state: any = false,
  actions: any
) => {
  switch (actions.type) {
    case PUT_TRANSPORTCOMPANIES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case PUT_TRANSPORTCOMPANIES_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case PUT_TRANSPORTCOMPANIES_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
